const API = process.env.REACT_APP_BACKEND_URL;

export const getToken = () => localStorage.getItem("abhyas_token");
export const setToken = (t) => localStorage.setItem("abhyas_token", t);

export const apiFetch = async (path, { method = "GET", body } = {}) => {
  const headers = { "Content-Type": "application/json" };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  // Default credentials ("same-origin") sends the session cookie automatically in
  // production where frontend and API share an origin; Bearer token covers the rest.
  const res = await fetch(`${API}/api${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = data.detail;
    throw new Error(
      typeof detail === "string"
        ? detail
        : Array.isArray(detail)
          ? detail.map((e) => e?.msg).filter(Boolean).join(" ")
          : data.status
            ? JSON.stringify(data)
            : "Something went wrong. Please try again."
    );
  }
  return data;
};

export const apiUpload = async (path, file) => {
  const token = getToken();
  const form = new FormData();
  form.append("file", file);
  const res = await fetch(`${API}/api${path}`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(
      typeof data.detail === "string" ? data.detail : "Upload failed. Please try again."
    );
  }
  return data;
};

export const apiFetchBlob = async (path) => {
  const token = getToken();
  const res = await fetch(`${API}/api${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(
      typeof data.detail === "string" ? data.detail : "Could not load the file."
    );
  }
  return res.blob();
};
